import { render, staticRenderFns } from "./KnInventoryMovementTypes.vue?vue&type=template&id=b844584a"
import script from "./KnInventoryMovementTypes.js?vue&type=script&lang=js&external"
export * from "./KnInventoryMovementTypes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports